export default {
  en: {
    agentType: 'Agent Type',
    editAgentType: 'Edit Agent Type',
    back: 'Back',
    name: 'Name',
    description: 'Description',
    saveChanges: 'Save Changes',
    updateAgentTypeSuccessTitle: 'Success',
    updateAgentTypeSuccessMessage: 'Update Agent Type Success.'
  },
  th: {
    agentType: 'ประเภทตัวแทน',
    editAgentType: 'แก้ไขประเภทตัวแทน',
    back: 'กลับ',
    name: 'ชื่อ',
    description: 'รายละเอียด',
    saveChanges: 'บันทึก',
    updateAgentTypeSuccessTitle: 'สำเร็จ',
    updateAgentTypeSuccessMessage: 'แก้ไขประเภทตัวแทนสำเร็จ'
  }
}
